import { render } from "./DownloadInstructions.vue?vue&type=template&id=4a26d782&scoped=true&ts=true"
import script from "./DownloadInstructions.vue?vue&type=script&lang=ts"
export * from "./DownloadInstructions.vue?vue&type=script&lang=ts"

import "./DownloadInstructions.vue?vue&type=style&index=0&id=4a26d782&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a26d782"]])

export default __exports__